import { S } from '../../core/state.js';
import { MAX_GRADE, BSTONE_KEY } from '../../world/map.js';
import { eqName, gearEdge, gearGlyph, gradeCol, lore, muted, npcHead, num, stock } from './common.js';

/** 심층에서 포탈을 누르면 열리는 전설 대장장이 작업대. */
export function render({ y, eq, j }) {
  const smith = S.legendarySmith || S.lair?.smith;
  const stones = stock(y, BSTONE_KEY);
  const usable = eq.filter((e) => !e.crude);
  let h = npcHead() + `<div class="sec"><h3>전설의 대장장이 <em>축복받은 강화석 ${num(stones)}개 보유</em></h3>
    <div class="ux-facts"><div class="ux-fact"><small>승급 · 축복받은 강화석</small><b><span class="ux-number">30</span><small>개 · 하루 한 번</small></b></div>
    <div class="ux-fact"><small>축복 · 축복받은 강화석</small><b><span class="ux-number">5</span><small>개</small></b></div></div>
    ${muted('<b>승급하면 강화 수치는 +0이 된다.</b> 최대 신화까지 · 장비 한 개만 승급')}`;
  // 2026-10-21 「논문 쓰니?」 — 값(30·5개)은 위에 한 번만 적고 장비 줄 버튼은 「승급」「축복」 두 글자로(전에는 같은 값이 줄마다 섰다).
  // 승급하면 강화가 +0 이 되는 것(되돌릴 수 없다)은 값 줄에 같이 둔다.
  if (!smith) h += muted('포탈 위치를 확인하는 중이다.');
  if (!usable.length) h += muted('맡길 장비가 없다. 조잡하지 않은 장비를 가지고 포탈을 찾아온다.');
  else h += usable.map((e) => {
    const grade = Number(e.grade || 0);
    const top = grade >= MAX_GRADE - 1;
    return `<div class="item gd" ${gearEdge(e)}><span class="nm" style="color:${gradeCol(grade)}">${gearGlyph(e.slot, grade)} ${eqName(e)}<span class="qt">${top ? '신화 상한' : '승급 시 다음 등급 +0'}${e.blessed ? ' · 축복됨' : ''}</span></span>
      <span class="row"><button ${top ? 'disabled' : ''} onclick="act.legendarySmith('promote','${e.id}')">${top ? '신화 상한' : '승급'}</button>
      <button ${e.blessed ? 'disabled' : ''} onclick="act.legendarySmith('bless','${e.id}')">${e.blessed ? '축복됨' : '축복'}</button></span></div>`;
  }).join('');
  h += `</div>${lore('규칙', '심층 포탈의 위치는 시간마다 바뀐다. 승급은 하루 한 번, 장비 한 개만 가능하며 최대 신화 등급까지 올린다. 승급하면 강화 수치는 +0이 된다. 이미 축복된 장비는 축복할 수 없다.')}`;
  return h;
}
